export default {
    label_task:{
        en:"Dealer Types",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Dealer Type",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Dealer Type",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Dealer Type",
        bn:'ব্যবহারকারীর বিবরণ'
    },
}